function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHammer = function SvgHammer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_890",
    width: 24,
    height: 24,
    "data-name": "Group 890",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_354",
    d: "M0 0h24v24H0z",
    "data-name": "Path 354",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_355",
    d: "M13.548 6.571V2h2.286a.762.762 0 0 1 .762.762V5.81a.762.762 0 0 1-.762.762zm-1.524 10.667a.762.762 0 0 1-.762.762H8.214a.762.762 0 0 1-.762-.762V6.571H2.5V5.1a.762.762 0 0 1 .378-.658L7.071 2h4.952z",
    "data-name": "Path 355",
    transform: "translate(2 2)",
    style: {
      fill: "currentColor"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHammer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hammer.2f0f550f.svg";
export { ForwardRef as ReactComponent };